module.exports = __webpack_public_path__ + "static/manabu-desk-b9fc5e42c55d806f6a2426e634ca1ccc.png";